import { createFileRoute } from "@tanstack/react-router";
import { ComingSoon } from "@/components/ComingSoon";

export const Route = createFileRoute("/_authed/api-keys")({
  component: () => (
    <ComingSoon
      title="API keys"
      phase="Phase 10"
      summary="Issue, scope, monitor, and revoke API keys for partners and internal services."
    />
  ),
});
